import * as React from 'react';
import { FormData } from '@shopee/form-with-hook';
import { APIProgress, APIState } from '@tob/shared/api-constants';

const DO_NOTHING = () => {};

export type RequirePasswordStateType = {
  state: {
    apiState: APIState;
    formValues: {
      authKey: string;
      password: string;
    };
    shouldShowCaptcha: boolean;
    initialAuthKey: string;
    showSmallScreenResetPasswordLink: boolean;
  };
  components: {
    ResetPasswordLink: () => JSX.Element | null;
  };
  onSubmitForm: (formData: FormData, isValidForm: boolean) => Promise<void>;
};

const defaultRequirePasswordState: RequirePasswordStateType = {
  state: {
    apiState: {
      progress: APIProgress.Success,
    },
    formValues: {
      authKey: '',
      password: '',
    },
    shouldShowCaptcha: false,
    initialAuthKey: '',
    showSmallScreenResetPasswordLink: false,
  },
  components: {
    ResetPasswordLink: () => null,
  },
  onSubmitForm: (DO_NOTHING as unknown) as (
    formData: FormData,
    isValidForm: boolean
  ) => Promise<void>,
};

export const LoginByPasswordRequirePasswordContext = React.createContext<
  RequirePasswordStateType
>(defaultRequirePasswordState);

export function useLoginByPasswordRequirePasswordContext() {
  const context = React.useContext(LoginByPasswordRequirePasswordContext);
  return context;
}
